import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const GET_DOMAIN_BIDDERS: TypedDocumentNode<Data, Variables> = gql`
  ${ALERT_FRAGMENT}

  query getDomainBidders($domainId: ID!) {
    domainBidders(domainId: $domainId) {
      nodes {
        csEnabled
        fieldAlerts {
          ...AlertFragment
        }
        id
        priority
        s2sEnabled
        updatedAt
        workspaceBidder {
          bidderCode
          bidder {
            id
            name
            s2sAvailable
          }
          id
          priority
          status
        }
      }
    }
  }
`
